import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const faqs = [
  {
    question: 'Is there a replacement for therapy?',
    answer:
      'No, NLP OS is not a replacement for professional therapy or mental health treatment. It is a self-discovery tool designed to help you understand your personality traits, strengths, and growth areas. If you are experiencing mental health challenges, please consult with a qualified healthcare professional.',
  },
  {
    question: 'How long does the assessment take?',
    answer:
      'The complete NLP OS assessment typically takes 15-20 minutes to complete. We recommend finding a quiet time when you can focus without distractions to get the most accurate results.',
  },
  {
    question: 'Is my personal health data safe?',
    answer:
      'Yes, your data privacy and security are our top priorities. We use industry-standard encryption and never share your personal information with third parties. Your assessment results are stored securely and only accessible to you and any coaches you choose to share them with.',
  },
  {
    question: 'Can I use NLP OS for free?',
    answer:
      'Yes, we offer a free assessment experience that includes your basic personality profile. Premium features like detailed AI analysis, coach connections, and progress tracking are available through our subscription plans.',
  },
  {
    question: 'What devices can I use NLP OS on?',
    answer:
      'NLP OS is a web-based application that works on any device with a modern web browser, including desktop computers, laptops, tablets, and smartphones. Your progress syncs automatically across all your devices.',
  },
];

export function NLPFAQ() {
  return (
    <section id="faq" className="py-20 md:py-28 px-4 md:px-8 bg-nlp-bg">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-nlp-cream rounded-full mb-4">
            <span className="text-sm font-semibold text-nlp-forest">FAQ</span>
          </div>
          <h2
            className="text-3xl md:text-4xl font-bold text-nlp-forest mb-4"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-nlp-taupe">
            Have any questions? Please see below first section.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left text-lg text-nlp-forest">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base text-nlp-taupe">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
